import { render, staticRenderFns } from "./AgentTransactionList.vue?vue&type=template&id=0051edb2&scoped=true"
import script from "./AgentTransactionList.vue?vue&type=script&lang=js"
export * from "./AgentTransactionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0051edb2",
  null
  
)

export default component.exports